<main class="conta-pagina" aria-labelledby="titulo-conta">
  <section class="conta-shell" *ngIf="carregando" aria-live="polite">
    <div class="conta-carregando">
      <span class="conta-spinner" aria-hidden="true"></span>
      <strong>Buscando sua conta</strong>
      <p>Conferindo os pedidos desta comanda…</p>
    </div>
  </section>

  <section class="conta-shell" *ngIf="!carregando && erro">
    <button class="conta-voltar" type="button" (click)="volteAoCardapio()" aria-label="Voltar ao cardápio">
      <i class="fas fa-arrow-left"></i>
    </button>
    <div class="conta-estado conta-estado-erro">
      <span class="conta-estado-icone"><i class="fas fa-link"></i></span>
      <p class="conta-sobretitulo">Acesso à conta</p>
      <h1 id="titulo-conta">Vamos vincular sua comanda novamente</h1>
      <p>{{erro}}</p>
      <button class="acao-primaria" type="button" (click)="volteAoCardapio()">Voltar ao cardápio</button>
    </div>
  </section>

  <section class="conta-shell conta-sucesso" *ngIf="!carregando && !erro && sucesso">
    <div class="sucesso-selo" aria-hidden="true"><i class="fas fa-check"></i></div>
    <p class="conta-sobretitulo">Pagamento confirmado</p>
    <h1 id="titulo-conta">Tudo certo, obrigado!</h1>
    <p>Recebemos seu Pix e a conta está quitada. Bateu vontade de mais alguma coisa? É só escanear o QR code da mesa de novo — será um prazer atender.</p>
    <div class="sucesso-resumo" *ngIf="comanda">
      <div class="sucesso-resumo-linha sucesso-resumo-principal">
        <span>{{comanda.empresa?.identificadorMesa || 'Mesa'}} {{comanda.mesa?.nome}}</span>
        <strong>{{comanda.totalComTaxa | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</strong>
      </div>
      <div class="sucesso-resumo-linha">
        <span>Forma de pagamento</span>
        <span class="sucesso-resumo-pix"><app-icone-pix [tamanho]="13"></app-icone-pix> Pix</span>
      </div>
      <div class="sucesso-resumo-linha" *ngIf="comanda.nomeCliente">
        <span>Pago por</span>
        <span>{{comanda.nomeCliente}}</span>
      </div>
      <div class="sucesso-resumo-linha" *ngIf="comanda.horarioFechamentoDescricao">
        <span>Conta fechada em</span>
        <span>{{comanda.horarioFechamentoDescricao}}</span>
      </div>
      <div class="sucesso-resumo-linha" *ngIf="comanda.codigoCartaoCliente || comanda.codigo">
        <span>Comanda</span>
        <span>{{comanda.codigoCartaoCliente || comanda.codigo}}</span>
      </div>
    </div>
    <button class="acao-primaria" type="button" (click)="conclua()">Voltar ao cardápio</button>
  </section>

  <ng-container *ngIf="!carregando && !erro && !sucesso && comanda">
    <section class="conta-shell" *ngIf="!pagamento">
      <header class="conta-cabecalho">
        <button class="conta-voltar" type="button" (click)="volteAoCardapio()" aria-label="Voltar ao cardápio">
          <i class="fas fa-arrow-left"></i>
        </button>
        <div>
          <p class="conta-sobretitulo">Sua conta</p>
          <h1 id="titulo-conta">{{comanda.empresa?.identificadorMesa || 'Mesa'}} {{comanda.mesa?.nome}}</h1>
          <p class="conta-identificacao">Comanda {{comanda.codigoCartaoCliente || comanda.codigo}}</p>
        </div>
      </header>

      <div class="conta-aviso conta-aviso-pagamento" *ngIf="comanda.possuiPedidosEmAndamento" role="status">
        <span><i class="fas fa-receipt"></i></span>
        <div>
          <strong>Você já pode pagar sua conta</strong>
          <p>O valor inclui todos os pedidos abaixo, mesmo os que ainda estão sendo preparados.</p>
        </div>
      </div>

      <div class="conta-aviso conta-aviso-neutro" *ngIf="!comanda.pixOnlineDisponivel" role="status">
        <span><i class="fas fa-user-clock"></i></span>
        <div>
          <strong>Fechamento com a equipe</strong>
          <p>Quando quiser encerrar, é só chamar o garçom — ele leva a conta até você e o pagamento é feito na mesa.</p>
        </div>
      </div>

      <section class="pedidos" aria-labelledby="titulo-pedidos">
        <div class="secao-titulo">
          <h2 id="titulo-pedidos">Pedidos</h2>
          <span>{{comanda.pedidos?.length || 0}}</span>
        </div>

        <article class="pedido" *ngFor="let pedido of comanda.pedidos">
          <header>
            <strong>Pedido #{{pedido.codigo}}</strong>
            <span [class.status-concluido]="pedido.statusOrdem === 4">{{pedido.status}}</span>
          </header>
          <div class="item" *ngFor="let item of pedido.itens">
            <span class="item-quantidade">{{item.qtde}}×</span>
            <div class="item-descricao">
              <strong>{{item.descricao}}</strong>
              <small *ngIf="item.observacao">{{item.observacao}}</small>
            </div>
            <span class="item-valor">{{item.total | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</span>
          </div>
        </article>
      </section>

      <section class="resumo" aria-labelledby="titulo-resumo">
        <h2 id="titulo-resumo">Resumo da conta</h2>
        <div>
          <span>Subtotal</span>
          <span>{{(comanda.valor + comanda.desconto) | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</span>
        </div>
        <div *ngIf="comanda.desconto > 0" class="resumo-desconto">
          <span>Desconto</span>
          <span>− {{comanda.desconto | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</span>
        </div>
        <div *ngIf="comanda.taxaServico > 0">
          <span>Taxa de serviço</span>
          <span>{{comanda.taxaServico | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</span>
        </div>
        <div *ngFor="let pagamentoAnterior of pagamentosConfirmados()" class="resumo-desconto">
          <span>{{pagamentoAnterior.descricao || 'Pagamento anterior'}}</span>
          <span>− {{pagamentoAnterior.valor | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</span>
        </div>
        <div class="resumo-total">
          <span>Saldo a pagar</span>
          <strong>{{comanda.saldoPagar | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</strong>
        </div>
      </section>

      <div class="conta-feedback" *ngIf="aviso" role="status" aria-live="polite">{{aviso}}</div>

      <footer class="conta-acoes">
        <ng-container *ngIf="comanda.pixOnlineDisponivel; else acaoSemPix">
          <button class="acao-primaria" type="button" (click)="abraConfirmacao()"
                  [disabled]="comanda.saldoPagar <= 0">
            <span class="acao-primaria-rotulo"><app-icone-pix [tamanho]="18"></app-icone-pix> Pagar com Pix</span>
            <strong>{{comanda.saldoPagar | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</strong>
          </button>
          <button class="acao-secundaria" type="button" (click)="soliciteGarcom()">
            <i class="far fa-bell"></i> Chamar garçom
          </button>
        </ng-container>
        <ng-template #acaoSemPix>
          <button class="acao-primaria acao-primaria-centralizada" type="button" (click)="soliciteGarcom()">
            <span class="acao-primaria-rotulo"><i class="far fa-bell" aria-hidden="true"></i> Pedir a conta ao garçom</span>
          </button>
        </ng-template>
      </footer>
    </section>

    <section class="conta-shell pix-shell" *ngIf="pagamento">
      <header class="conta-cabecalho pix-cabecalho">
        <button class="conta-voltar" type="button" (click)="cancelePix()" [disabled]="cancelando"
                *ngIf="pagamento.cancelamentoDisponivel"
                aria-label="Cancelar Pix e voltar para a conta">
          <i class="fas fa-arrow-left"></i>
        </button>
        <div>
          <p class="conta-sobretitulo">Pix gerado</p>
          <h1 id="titulo-conta">Pague pelo app do seu banco</h1>
        </div>
      </header>

      <div class="pix-tempo" [class.pix-tempo-expirado]="pixExpirado">
        <span><i class="far fa-clock"></i> {{pixExpirado ? 'Código expirado' : 'Expira em'}}</span>
        <strong *ngIf="!pixExpirado">{{formateTempo()}}</strong>
      </div>

      <div class="pix-layout" *ngIf="!pixExpirado">
        <div class="pix-conteudo">
          <div class="pix-valor">
            <span>Valor do pagamento</span>
            <strong>{{pagamento.valor | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</strong>
          </div>
          <button class="acao-primaria pix-copiar" type="button" (click)="copiePix()">
            <i [class]="pixCopiado ? 'fas fa-check' : 'far fa-copy'" aria-hidden="true"></i>
            {{pixCopiado ? 'Código copiado!' : 'Copiar código Pix'}}
          </button>
          <ol class="pix-passos">
            <li>Toque em <strong>Copiar código Pix</strong> aqui em cima.</li>
            <li>Abra o app do seu banco e escolha <strong>Pix Copia e Cola</strong>.</li>
            <li>Cole o código, confira o valor e confirme.</li>
          </ol>
          <div class="pix-codigo" aria-label="Código Pix copia e cola">{{pagamento.codigoQrCode}}</div>
        </div>
        <div class="pix-qr">
          <span class="pix-qr-titulo">Outra pessoa vai pagar?</span>
          <img [src]="obtenhaUrlQrCode()" alt="QR Code para pagamento Pix">
          <small>Mostre este QR code pra ela escanear com o app do banco dela.</small>
        </div>
      </div>

      <div class="conta-estado conta-estado-expirado" *ngIf="pixExpirado">
        <span class="conta-estado-icone"><i class="far fa-clock"></i></span>
        <h2>O tempo deste Pix terminou</h2>
        <p>Nenhuma cobrança foi feita. Volte à conta para gerar um novo código.</p>
        <button class="acao-primaria" type="button" (click)="volteParaConta()" [disabled]="cancelando">
          {{cancelando ? 'Atualizando…' : 'Atualizar conta'}}
        </button>
      </div>

      <div class="pix-status" *ngIf="!pixExpirado" aria-live="polite">
        <span class="conta-spinner conta-spinner-pequeno" aria-hidden="true"></span>
        <div>
          <strong>Aguardando confirmação</strong>
          <small>Esta tela atualiza automaticamente após o pagamento.</small>
        </div>
      </div>
      <div class="conta-feedback" *ngIf="aviso" role="status" aria-live="polite">{{aviso}}</div>
      <button class="pix-cancelar" type="button" (click)="cancelePix()" [disabled]="cancelando"
              *ngIf="!pixExpirado && pagamento.cancelamentoDisponivel">
        {{cancelando ? 'Cancelando…' : 'Cancelar este Pix'}}
      </button>
    </section>
  </ng-container>
</main>

<div class="confirmacao-fundo" *ngIf="confirmandoPagamento" (click)="fecheConfirmacao()"></div>
<section class="confirmacao" *ngIf="confirmandoPagamento" role="dialog" aria-modal="true" aria-labelledby="titulo-confirmacao">
  <div class="confirmacao-puxador" aria-hidden="true"></div>
  <button class="confirmacao-fechar" type="button" (click)="fecheConfirmacao()" aria-label="Fechar">
    <i class="fas fa-times"></i>
  </button>
  <p class="conta-sobretitulo">Antes de gerar o Pix</p>
  <h2 id="titulo-confirmacao">Confirme o pagamento da conta</h2>
  <div class="confirmacao-total">
    <span>Total no Pix</span>
    <strong>{{comanda?.saldoPagar | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</strong>
  </div>
  <label for="nome-pagador">Nome de quem está pagando</label>
  <input id="nome-pagador" name="nomePagador" type="text" [(ngModel)]="nomeCliente"
         autocomplete="name" placeholder="Digite seu nome" [disabled]="gerando">
  <p class="confirmacao-nota"><i class="fas fa-lock"></i> Após gerar, a comanda fica em fechamento e novos itens não poderão ser adicionados até pagar ou o código expirar.</p>
  <div class="conta-feedback" *ngIf="aviso" role="alert" aria-live="assertive">{{aviso}}</div>
  <button class="acao-primaria" type="button" (click)="gerePix()" [disabled]="gerando">
    <span>{{gerando ? 'Gerando Pix…' : 'Gerar Pix'}}</span>
    <strong *ngIf="!gerando">{{comanda?.saldoPagar | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</strong>
  </button>
</section>
